import React from 'react'
import { SectionHeader } from 'src/components/framework/ui/section-header'
import { MarketRatioTable } from 'src/components/page/ratios/market-ratio-table'
import {
  MarketRatioRow,
  RatioTableData,
  buildMarketRatioRows,
} from 'src/components/page/ratios/ratios'
import { useFeaturesContext } from 'src/contexts/features.context'
import { useSecurityContext } from 'src/contexts/security.context'
import { GrowthRatioType } from 'src/shared/growth-ratio'
import { ValuationRatioType } from 'src/shared/valuation-ratio'

export const GrowthValueRatios: React.FC = () => {
  const { features } = useFeaturesContext()
  const { security } = useSecurityContext()

  const dataSource = security.ratios
  const featureFlags = features.ratios

  const data: GrowthValueTableData = [
    {
      label: '12m Forecast Rolling',
      rows: buildMarketRatioRows<GrowthRatioType>(
        GROWTH_DATA,
        featureFlags.growth,
        dataSource.growth,
      ),
    },
    {
      label: 'Valuation (ttm)',
      rows: buildMarketRatioRows<ValuationRatioType>(
        VALUATION_DATA,
        featureFlags.valuation,
        dataSource.valuation,
      ),
    },
  ]

  return (
    <>
      <SectionHeader>Growth &amp; Value</SectionHeader>
      <div className={'stk-table-group'} style={{ whiteSpace: 'nowrap' }}>
        {data.map((table, tableIndex) => (
          <MarketRatioTable
            label={{ text: table.label, visible: true }}
            rows={table.rows}
            key={tableIndex}
          />
        ))}
      </div>
    </>
  )
}

const GROWTH_DATA: ReadonlyArray<MarketRatioRow<GrowthRatioType>> = [
  {
    id: 'PE',
    label: 'PE Ratio (f)',
    ratioId: 'price-to-earnings-ratio-rolling-1-year-forecast-700',
    enabled: false,
  },
  {
    id: 'PEG',
    label: 'PEG Ratio (f)',
    ratioId: 'price-earnings-to-growth-ratio-rolling-661',
    enabled: false,
  },
  {
    id: 'EPS',
    label: 'EPS Growth (f)',
    ratioId: 'earnings-per-share-growth-forecast-rolling-1-year-577',
    enabled: false,
  },
  {
    id: 'yield',
    label: 'Dividend Yield (f)',
    ratioId: 'dividend-yield-rolling-1-year-forecast-282',
    unit: '%',
    enabled: false,
  },
]

const VALUATION_DATA: ReadonlyArray<MarketRatioRow<ValuationRatioType>> = [
  {
    id: 'priceToBook',
    label: 'Price to Book Value',
    ratioId: 'price-to-book-value-696',
    enabled: false,
  },
  {
    id: 'priceToTang',
    label: 'Price to Tang. Book',
    ratioId: 'price-to-tangible-book-value-746',
    enabled: false,
  },
  {
    id: 'priceToCashflow',
    label: 'Price to Free Cashflow',
    ratioId: 'price-to-free-cash-flow-733',
    enabled: false,
  },
  {
    id: 'priceToSales',
    label: 'Price to Sales',
    ratioId: 'price-to-sales-ratio-745',
    enabled: false,
  },
  {
    id: 'evToEbita',
    label: 'EV to EBITDA',
    ratioId: 'enterprise-value-to-ebitda-342',
    enabled: false,
  },
]

type GrowthValueTableData = RatioTableData<
  MarketRatioRow<GrowthRatioType | ValuationRatioType>
>[]
